<template>
  <div class="text-center">
    <v-dialog v-model="dialog" max-width="700" persistent>
      <v-card>
        <v-card-text>
          <h4 class="pt-4 text-center">Verificar y confirmar la informacion</h4>

          <v-row>
            <v-col cols="12">
              <p class="my-1"><b>Programa:</b> {{ contacto.programa_name }}</p>
              <p class="my-1"><b>Estudiante:</b> {{ contacto.persona_name }}</p>
              <p class="my-1"><b>Tipo ins:</b> {{ contacto.tipo_inscripcion }}</p>
              <p class="my-1"><b>Plan de pago:</b> {{ contacto.plan_pago }}</p>
              <p class="my-1"><b>Estado:</b> {{ contacto.estado }}</p>
            </v-col>

            <v-col v-for="(a, ind) in contacto.documentos" :key="ind" cols="12">
              <p class="my-1"><b>Tipo:</b> {{ a.tipo }}</p>
              <p class="my-1"><b>Subido:</b> {{ a.fecha_carga }}</p>

              <div v-if="a.file64 && a.file64.length>5">
                <iframe :src="a.file64" frameborder="1" style="width: 100%; height: 500px" />
              </div>
            </v-col>

            <v-col>
              <v-text-field
                :loading="loading_docs"
                :disabled="loading_docs"
                label="Para indicar todo correcto, escriba: verificado"
                v-model="textoconfirmar"
                prepend-icon="mdi-check"
                type="text" />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" :disabled="loading || textoconfirmar != 'verificado'" outlined @click="enviar()">
            confirmar informacion
          </v-btn>
          <v-btn color="red" outlined @click="cerrar()"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { getFileServer, setVerificacion_contable } from './utils';
  export default {
    components: {},
    data() {
      return {
        loading: false,
        loading_docs: false,
        dialog: false,
        contacto: {},
        textoconfirmar: '',
      };
    },
    computed: {},
    watch: {},
    methods: {
      async openmodal(row) {
        const rs = JSON.parse(JSON.stringify(row));
        rs.documentos.map((x) => {
          x.file64 = 'x';
        });
        this.textoconfirmar = '';
        this.contacto = rs;
        this.loading = false;
        this.dialog = true;
        this.getfiles();
      },
      cerrar() {
        this.dialog = false;
      },
      async getfiles() {
        this.loading_docs = true
        for (let i = 0; i < this.contacto.documentos.length; i++) {
          const ex = this.contacto.documentos[i];
          ex.file64 = await getFileServer(ex.url_archivo);
        }
        this.loading_docs = false
      },

      async enviar() {
        const us = this.$store.state.DATA_USER;
        if (!us.seg_apellido) us.seg_apellido = '';
        const us_name = `${us.nombres} ${us.pri_apellido} ${us.seg_apellido}`.trim();

        const d = {
          pre_registro_id: this.contacto.id,
          contadora_id: us.id,
          contadora_name: us_name,
        };
        const res = await setVerificacion_contable(d);
        this.$emit('success')
        if (res && res.id) {
          const t = 'NO OLVIDES COMUNICAR AL ASESOR.';
          this.$root.$notify.show('Listo, ahora se puede proceder con la inscripcion al programa. ' + t, {
            color: 'green',
            x: 'right',
            timeout: 10000,
          });
          this.cerrar();
        } else if (res && res.error) {
          this.$root.$notify.show(res.error, { color: 'red', x: 'right' });
        }
      },
    },
    mounted() {},
  };
</script>
